enum unitTypes {
  apartment = "APARTMENT",
  room = "ROOM",
  hut = "HUT",
  resort = "RESORT",
  chalet = "CHALET",
}

enum bookingTypes {
  completed = "COMPLETED",
  confirmed = "CONFIRMED",
  pending = "PENDING",
  canceled = "CANCELLED",
  paymentExpired = "PAYMENT_EXPIRED",
}

enum instructionTypes {
  reception = "RECEPTION",
  call = "CALL",
  chat = "CHAT",
  self = "SELF",
  other = "OTHER",
}

export { unitTypes, bookingTypes, instructionTypes };
